<!--  -->
<template>
  <div>
    <el-form v-loading="loadingtable" label-position="right" label-width="90px">
      <el-form-item v-if="type === 1 && selecttype === 1" label="选择员工">
        <div class="chooser_box">
          <el-tag v-for="items,index in employee_nos" :key="index" style="margin-right:10px" closable @close="handleClose(index)">{{ items.name }} </el-tag>
        </div>
        <el-button type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item v-if="selecttype === 2" label="选择区间值">
        <div class="chooser_box dae_nox">
          <el-input v-model="integral_min" type="number" placeholder="最小值" style="width: 100px;margin: 0px 10px 0px 0px;" />  -  <el-input v-model="integral_max" placeholder="最大值" type="number" style="width: 100px;margin: 0px 0px 0px 10px;" />
        </div>
      </el-form-item>
      <el-form-item v-if="type === 2 && selecttype === 1" label="选择员工">
        <div class="chooser_box">
          <el-tag v-if="employee_no!=''" style="margin-right:10px">{{ name }} </el-tag>
        </div>
        <!-- <el-button type="primary" size="mini" @click="chsewrw">选择企业员工</el-button> -->
      </el-form-item>
      <el-form-item label="每分钟数">
        <el-input v-model="min" placeholder="请输入每分钟数" type="number" min="1" style="width: 150px;" />
      </el-form-item>
      <!-- <el-form-item v-if="Object.keys(customer).length > 0" label="私聊">
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">文本</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="customer.sp_text.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="customer.sp_text.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="customer.sp_text.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">图片</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="customer.sp_image.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="customer.sp_image.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="customer.sp_image.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">链接</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="customer.sp_link.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="customer.sp_link.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="customer.sp_link.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">小程序</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="customer.sp_miniprogram.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="customer.sp_miniprogram.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="customer.sp_miniprogram.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
      </el-form-item> -->
      <!-- <el-form-item v-if="Object.keys(group_chat).length > 0" label="群聊">
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">文本</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="group_chat.sp_text.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="group_chat.sp_text.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="group_chat.sp_text.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">图片</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="group_chat.sp_image.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="group_chat.sp_image.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="group_chat.sp_image.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">链接</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="group_chat.sp_link.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="group_chat.sp_link.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="group_chat.sp_link.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
        <div class="dae_nox dae_noxwr">
          <div class="text_boxr">小程序</div>
          <div class="dae_nox">
            <div class="dae_nox">
              <div class="dasdwr">每分钟：</div>
              <el-input v-model="group_chat.sp_miniprogram.min" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每小时：</div>
              <el-input v-model="group_chat.sp_miniprogram.house" type="number" style="width: 100px;" />
            </div>
            <div class="dae_nox">
              <div class="dasdwr">每天：</div>
              <el-input v-model="group_chat.sp_miniprogram.day" type="number" style="width: 100px;" />
            </div>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" :disabled="disabled" @click="sumbitr">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <choosepeol ref="choosepeolview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="选择员工"
      :visible.sync="dialogVisiblerse"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <choserdan ref="choserdanview" @choserdanr="choserdanr" />
    </el-dialog>
  </div>

</template>

<script>
import choosepeol from './choosepeol.vue'
import choserdan from './choserdan.vue'
import { getFrequency, frequencystore, frequencyindex, frequencyupdate, integralFrequencystore, integralFrequencyupdate } from '@/api/officialaccount.js'
export default {
  components: { choosepeol, choserdan },
  data() {
    return {
      type: null,
      id: null,
      employee_nos: [],
      dialogVisibler: false,
      customer: {},
      group_chat: {},
      employee_nosall: [],
      name: '',
      employee_no: '',
      loadingtable: false,
      dialogVisiblerse: false,
      disabled: false,
      selecttype: null,
      integral_min: '',
      integral_max: '',
      ids: null,
      min: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item, selecttype) {
      this.type = type
      // this.id = id
      console.log(type, item)
      this.selecttype = selecttype
      if (selecttype === 1) {
        if (type === 1) {
          // this.list()
        } else {
        // this.menuList()
          this.customer = {}
          this.group_chat = {}
          this.name = ''
          this.employee_no = ''
          // this.customer = item.frequency.customer
          // this.group_chat = item.frequency.group_chat
          this.min = item.min_frequency
          this.name = item.name
          this.employee_no = item.employee_no
        }
      } else {
        if (type === 1) {
          // this.list()
        } else {
        // this.menuList()
          this.customer = {}
          this.group_chat = {}
          // this.customer = item.frequency.customer
          // this.group_chat = item.frequency.group_chat
          this.min = item.min_frequency
          this.integral_min = item.integral_min
          this.integral_max = item.integral_max
          this.ids = item.id
        }
      }
    },
    async list() {
      this.loadingtable = true
      const data = await getFrequency()
      console.log('data', data.data.customer)
      this.loadingtable = false
      this.customer = data.data.customer
      this.group_chat = data.data.group_chat
    },
    async menuList() {
      // 获取列表
      this.loadingtable = true
      const data = await frequencyindex({
        page: 1,
        page_size: 10,
        id: this.id
      })
      this.customer = data.data.list[0].frequency.customer
      this.group_chat = data.data.list[0].frequency.group_chat
      this.name = data.data.list[0].name
      this.employee_no = data.data.list[0].employee_no
      this.loadingtable = false
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.choosepeolview.sendr(this.employee_nos)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.employee_nos = arr
      console.log(arr)
    },
    handleClose(index) {
      this.employee_nos.splice(index, 1)
    },
    async sumbitr() {
      if (this.selecttype === 1) {
        if (this.type === 1) {
          if (this.employee_nos.length === 0) {
            this.$message.error('请选择员工')
            return
          }
          if (this.min === '') {
            this.$message.error('请输入分钟数')
            return
          }
          if (this.min < '0') {
            this.$message.error('请输入大于0的分钟数')
            return
          }
          this.employee_nosall = []
          this.employee_nosall = this.employee_nos.map(item => {
            return item.employee_no
          })
          try {
            this.disabled = true
            const data = await frequencystore({
              employee_nos: this.employee_nosall,
              min_frequency: Number(this.min)
              // frequency: { customer: this.customer, group_chat: this.group_chat }
            })

            this.$emit('updata')
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            console.log('1111', data)
          } catch {
            this.disabled = false
          }
        } else {
          if (this.employee_no === '') {
            this.$message.error('请选择员工')
            return
          }
          if (this.min === '') {
            this.$message.error('请输入分钟数')
            return
          }
          if (this.min < '0') {
            this.$message.error('请输入大于0的分钟数')
            return
          }
          try {
            this.disabled = true
            const data = await frequencyupdate({
              employee_no: this.employee_no,
              min_frequency: Number(this.min)
              // frequency: {
              //   customer: this.customer, group_chat: this.group_chat
              // }
            })
            this.$emit('updata')
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            console.log('2222', data)
          } catch {
            this.disabled = false
          }
        }
      } else {
        if (this.integral_min === '') {
          this.$message.error('请输入最小值')
          return
        }
        if (this.integral_max === '') {
          this.$message.error('请输入最大值')
          return
        }
        if (this.min === '') {
          this.$message.error('请输入分钟数')
          return
        }
        if (this.min < '0') {
          this.$message.error('请输入大于0的分钟数')
          return
        }
        if (this.type === 1) {
          console.log('新增')
          try {
            this.disabled = true
            const data = await integralFrequencystore({
              integral_min: this.integral_min,
              integral_max: this.integral_max,
              // frequency: { customer: this.customer, group_chat: this.group_chat }
              min_frequency: Number(this.min)
            })

            this.$emit('updata')
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            console.log('1111', data)
          } catch {
            this.disabled = false
          }
        } else {
          console.log('编辑')
          try {
            this.disabled = true
            const data = await integralFrequencyupdate({
              id: this.ids,
              integral_min: this.integral_min,
              integral_max: this.integral_max,
              // frequency: {
              //   customer: this.customer, group_chat: this.group_chat
              // }
              min_frequency: Number(this.min)
            })
            this.$emit('updata')
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            console.log('2222', data)
          } catch {
            this.disabled = false
          }
        }
      }
    },
    choserdanr(item) {
      this.dialogVisiblerse = false
      this.name = item.name
      this.employee_no = item.employee_no
      console.log(item)
    },
    chsewrw() {
      this.dialogVisiblerse = true
      this.$nextTick(() => {
        this.$refs.choserdanview.sendrs()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dae_nox{
  display: flex;
  align-items: center;
}
.dasdwr{
  margin-left: 10px;
}
.text_boxr{
  width: 45px;
  text-align: right;
}
.dae_noxwr{
  margin-bottom: 10px;
}
.chooser_box{
  max-height: 200px;
  overflow: auto;
}
::v-deep .dae_nox input::-webkit-outer-spin-button,
::v-deep .dae_nox input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
::v-deep .dae_nox input[type="number"] {
    -moz-appearance: textfield;
}
</style>
